import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop", "panel"];
  static values = {
    duration: { type: Number, default: 300 },
    width: { type: String, default: "100%" },
  };

  connect() {
    this.isOpen = false;
    this.boundKeydown = this.handleKeydown.bind(this);
    this.boundClose = this.close.bind(this);

    document.addEventListener("turbo:submit-end", this.boundClose);
    document.addEventListener("keydown", this.boundKeydown);

    // Add transition classes once
    this.backdropTarget.classList.add(
      "transition",
      `duration-${this.durationValue}`,
    );
    this.panelTarget.classList.add(
      "transition",
      `duration-${this.durationValue}`,
    );
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown);
    document.removeEventListener("turbo:submit-end", this.boundClose);
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
    }
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;

    // Lock scroll
    this.lockScroll();

    // Show and animate backdrop/panel
    this.backdropTarget.classList.remove("hidden");
    requestAnimationFrame(() => {
      this.backdropTarget.classList.add("ease-out");
      this.panelTarget.classList.add("ease-out");

      this.backdropTarget.classList.add("opacity-100");
      this.backdropTarget.classList.remove("opacity-0");
      this.panelTarget.classList.remove("translate-x-full");
      this.panelTarget.classList.add("translate-x-0");
    });

    this.panelTarget.scrollTop = 0;
  }

  close(e) {
    if (!this.isOpen) return;
    if (e?.type === "turbo:submit-end" && !e.detail.success) return;

    this.isOpen = false;
    this.unlockScroll();

    // Animate out
    this.backdropTarget.classList.remove("ease-out");
    this.panelTarget.classList.remove("ease-out");
    this.backdropTarget.classList.add("ease-in");
    this.panelTarget.classList.add("ease-in");

    this.backdropTarget.classList.remove("opacity-100");
    this.backdropTarget.classList.add("opacity-0");
    this.panelTarget.classList.remove("translate-x-0");
    this.panelTarget.classList.add("translate-x-full");

    // Cleanup after animation
    this.cleanup();
  }

  lockScroll() {
    this.scrollPosition = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = this.widthValue;
  }

  unlockScroll() {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, this.scrollPosition);
  }

  cleanup() {
    setTimeout(() => {
      if (!this.isOpen) {
        this.backdropTarget.classList.add("hidden");
        this.backdropTarget.classList.remove("ease-in");
        this.panelTarget.classList.remove("ease-in");
      }
    }, this.durationValue);
  }
}
